import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { CourseUpdateInfo } from "./CourseUpdateInfo";
import { CourseUpdateRequestModel } from "./CourseUpdateRequestModel";
import { DataService_CourseSetup } from "./shared/data.service";

@Component({
	selector: "app-course-setup",
	templateUrl: "./course-setup.component.html",
	styleUrls: ["./course-setup.component.css"],
})
export class CourseSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private CourseSetupService: DataService_CourseSetup,
		private SchoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchools();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	CourseTypeLoading: any = false;
	CourseLoading: any = false;

	SchoolID: any;
	lstSchool: any = [];

	CourseTypeList: any = [];

	DataChanged: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedCourse: any;
	lstCourse: any = [];

	//Filter lists
	lstDepartmentDesc: any = [];
	lstCourseType: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "CourseNo", header: "Course Number" },
		{ field: "CourseDesc", header: "Description" },
		{ field: "CourseCD", header: "Attendance" },
		{ field: "DepartmentDesc", header: "Department" },
		// { field: 'CourseType', header: 'Type' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	loadSchools() {
		var result = this.SchoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.SchoolID = this.lstSchool[0].SchoolID;

				this.loadCourseType();
			},
			(error) => {}
		);
	}

	loadCourseType() {
		this.CourseTypeLoading == true;

		var result = this.CourseSetupService.LoadCourseTypes();
		result.subscribe(
			(response) => {
				this.CourseTypeList = response;

				this.CourseTypeLoading == false;
				this.loadCourse();
			},
			(error) => {
				this.CourseTypeLoading == true;
			}
		);
	}

	loadCourse() {
		this.errorMessage = "";

		this.CourseLoading = true;

		var result = this.CourseSetupService.LoadCourse(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstCourse = response;

				//Load Data Filter Lists
				this.lstDepartmentDesc = Array.from(new Set(this.lstCourse.map((item: any) => item.DepartmentDesc))).sort();

				this.UpdateCourseTypeFilter();

				this.DataChanged = false;

				this.CourseLoading = false;
			},
			(error) => {
				this.CourseLoading = false;
			}
		);
	}

	UpdateCourseTypeFilter() {
		var UsedCTIDs = Array.from(new Set(this.lstCourse.map((item: any) => item.CourseTypeID))).sort();

		this.lstCourseType = [];
		for (var i = 0; i < UsedCTIDs.length; i++) {
			let nextID = UsedCTIDs[i];

			for (var z = 0; z < this.CourseTypeList.length; z++) {
				var nextCheck = this.CourseTypeList[z];

				if (nextID == nextCheck.CourseTypeID) {
					this.lstCourseType = [...this.lstCourseType, nextCheck];
					break;
				}
			}
		}
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadCourse();
	}

	//Custom Button Methods
	onUpdateCourse() {
		this.errorMessage = "";

		//Error handling
		if (this.DataChanged == false) {
			this.errorMessage = "Data hasn't changed";
			return;
		}

		//Create list of courses
		var lstCUI: CourseUpdateInfo[] = [];

		for (var i = 0; i < this.lstCourse.length; i++) {
			var next = this.lstCourse[i];

			if (next.Changed != undefined) {
				let nextCUI: CourseUpdateInfo = {
					CourseID: next.CourseID,
					CourseTypeID: next.CourseTypeID,
				};

				lstCUI = [...lstCUI, nextCUI];
			}
		}

		//Create request model
		let CUR: CourseUpdateRequestModel = {
			Courses: lstCUI,
		};

		var result = this.CourseSetupService.UpdateCourses(CUR);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Courses were updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadCourse();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update courses",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onCourseTypeChange(Course, val) {
		Course.CourseTypeID = val;
		Course.Changed = 1;

		this.DataChanged = true;

		this.UpdateCourseTypeFilter();
	}

	onSchoolChange(val) {
		this.SchoolID = val;

		// this.loadCourse();
		this.loadCourseType();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedCourse = val.data;
	}
	onRowUnselect(val) {
		this.SelectedCourse = null;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.CourseTypeLoading == true || this.CourseLoading == true;
	}

	////////////////////////////////////////////
}
